<div class="upgrade-logs-viewer tw-flex tw-flex-col tw-h-full tw-gap-4">
  <!-- Header -->
  <div class="tw-flex tw-justify-between tw-items-center">
    <lib-block-title [title]="labels.title || 'Upgrade Logs Viewer'"></lib-block-title>
    <button
      class="custom-mat-button-primary custom-mat-button-border"
      mat-button
      [title]="labels.refreshButton"
      (click)="onRefresh()">
      <mat-icon class="m-0">refresh</mat-icon>
    </button>
  </div>

  <!-- Main Content - Single Column -->
  <div class="tw-flex tw-flex-col tw-gap-4 tw-flex-1">
    <!-- Device Search Panel -->
    <lib-device-search
      [labels]="{
        deviceSerial: labels.deviceSerial,
        dateRange: labels.dateRange,
        status: labels.status,
        operator: labels.operator,
        search: labels.search,
        clear: labels.clear
      }"
      [filters]="currentFilter$ | async"
      (filterChanged)="onFilterChange($event)">
    </lib-device-search>

    <!-- Content Panel -->
    <div class="tw-flex tw-flex-col tw-gap-4 tw-flex-1">
      <!-- Session List -->
      <div class="tw-flex-1">
        <lib-session-list
          [sessions]="sessions$ | async"
          [loading]="(loading$ | async) || false"
          [selectedSession]="selectedSession$ | async"
          [labels]="{
            noDataMessage: labels.noDataMessage,
            loadingMessage: labels.loadingMessage,
            exportSession: labels.exportSession
          }"
          (sessionSelected)="onSelectSession($event)"
          (exportSession)="onExportSession($event)"
          (exportSgpCommands)="onExportSgpCommands($event)">
        </lib-session-list>
      </div>

      <!-- Session Details -->
      <div
        *ngIf="selectedSession$ | async as session"
        class="tw-flex-1">
        <!-- Header with session info and close button -->
        <div class="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-2 tw-mb-4">
          <div class="tw-flex tw-flex-col tw-gap-1">
            <h2 class="tw-text-lg tw-font-semibold text-grey-400 body-1">{{ session.deviceSerial }}</h2>
            <span class="tw-text-sm text-grey-400">{{ formatTimestamp(session.startTime) }}</span>
          </div>
          <button
            class="custom-mat-button-warning custom-mat-button-border"
            mat-button
            (click)="onClearSelection()">
            <mat-icon class="m-0">close</mat-icon>
          </button>
        </div>

        <!-- Session Details Content -->
        <ng-container *ngIf="sessionDetails$ | async as sessionDetails">
          <lib-session-details
            [sessionDetails]="sessionDetails"
            [labels]="{
              summary: labels.summary,
              events: labels.events,
              sgpCommands: labels.sgpCommands,
              deviceSnapshot: labels.deviceSnapshot
            }">
          </lib-session-details>
        </ng-container>
      </div>
    </div>
  </div>
</div>